import { Switch, Form } from 'antd'
import React from 'react'

function AdnSwitch({ name, label, onChange, defaultChecked, disabled, checkedText, unCheckedText, checked, rules, className }) {
    return (
        <div>
            <Form.Item name={name} label={label} className={className}>
                <Switch checkedChildren={checkedText}
                    unCheckedChildren={unCheckedText}
                    onChange={onChange}
                    defaultChecked={defaultChecked}
                    disabled={disabled}
                    rules={rules}
                    checked={checked} />
            </Form.Item>

        </div>
    )
}

export default AdnSwitch